import {call, fork, put} from "redux-saga/effects";
import * as Actions from "../global/actions";
import {GlobalConfigAPI} from "../../services/GlobalConfigAPI";
import {setMediaStorageBaseUrl} from '../../utils/media';

export function* fetchConfig() {
  try {
    const api = new GlobalConfigAPI();

    const {data: globalConfig} = yield call(api.fetchConfig);

    setMediaStorageBaseUrl(globalConfig.mediaConfig?.cropperUrl);
    yield put(Actions.fetchGlobalConfigSuccess(globalConfig));
  } catch (error) {
    yield put(Actions.fetchGlobalConfigFailure(error));
  }
}

export default [
  fork(fetchConfig),
];
